import styled from "styled-components";

export const Root = styled.div`
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
    margin: 0 -5px;

    ${({ theme }) => theme.breakpoints.lg.mediaquery} {
        flex-wrap: wrap;
    }
`;
